type ConflictResult = {
	environmentLabel: string
}

type applicationEnvironmentType = {
	label: string,
	value: string
}

const readString = (value: unknown) =>
	typeof value === 'string' ? value.trim() : ''

export const normalizeAlias = (value: unknown) =>
	readString(value).toLowerCase()

export const normalizeApplicationEnvironment = (value: unknown) => {
	const environmentValue =
		typeof value === 'object' && value !== null
			? readString((value as { value?: string }).value) ||
				readString((value as { label?: string }).label)
			: readString(value)

	const normalized = environmentValue.toLowerCase()
	return normalized
}

export const findApprovedGcpProjectAliasConflict = (
	projects: Array<any> | undefined,
	input: { alias: string; gcpProjectType: string }
): ConflictResult | undefined => {
	const alias = normalizeAlias(input.alias)
	const environment = readString(input.gcpProjectType)

	if (!alias || !environment || !projects) {
		return undefined
	}

	const hasConflict = projects.some((project) => {
		const projectAlias = normalizeAlias(project?.tags?.details?.systemAlias)
		const projectType =
			readString(project?.gcpProjectType) || readString(project?.type)

		return (
			project?.status === 'APPROVED' &&
			Boolean(projectAlias) &&
			Boolean(projectType) &&
			projectAlias === alias &&
			projectType === environment
		)
	})

	return hasConflict ? { environmentLabel: environment } : undefined
}

export const findApprovedApplicationAliasConflict = (
	applications : Array<any> | undefined,
	alias : string,
	environment : applicationEnvironmentType
): ConflictResult | undefined => {
	const normalizedAlias = normalizeAlias(alias)
	const environmentValue = environment.value
	const environmentLabel = environment.label

	if (!normalizedAlias || !environmentValue || !applications) {
		return undefined
	}

	const hasConflict = applications.some((application) => {
		const applicationAlias = normalizeAlias(
			application?.details?.applicationAlias
		)
		const applicationEnvironment = normalizeApplicationEnvironment(
			application?.details?.environment
		)

		return (
			application?.status === 'APPROVED' &&
			Boolean(applicationAlias) &&
			Boolean(applicationEnvironment) &&
			applicationAlias === alias &&
			applicationEnvironment === environmentValue
		)
	})

	return hasConflict ? { environmentLabel } : undefined
}
